var chunkToChildrenMap = {
	"src_app_core_modules_login-modals_login-modals_module_ts": [
		"src_theme_dark_less",
		"src_theme_less"
	],
	"src_app_home_home_module_ts": [
		"src_theme_dark_less",
		"src_theme_less"
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));